<template>
  <div class="container-node-edit">
    <Card shadow class="content">
      <div class="main">
        <Row class="title">
          <h4 :style="{float: 'left'}">{{ $route.params.id ? '编辑节点' : '添加节点' }}</h4>
        </Row>
        <Form inline :label-width="50" :rules="baseInfoFormRules" ref="baseInfo" :model="baseInfo">
          <Row>
            <FormItem label="名称" style="width: 100%" prop="name">
              <Input :maxlength="100" v-model="baseInfo.name" placeholder="请填写节点名称"/>
            </FormItem>
            <FormItem label="URL" style="width: 100%" prop="url">
              <Input :maxlength="512" v-model="baseInfo.url" placeholder="如：192.168.1.10:2375 / mydocker.mydomain.com:2375"/>
            </FormItem>
            <FormItem label="TLS" style="width: 100%" prop="is_tls">
              <i-switch size="large" v-model="baseInfo.is_tls">
                <span slot="open">开启</span>
                <span slot="close">关闭</span>
              </i-switch>
            </FormItem>
            <div v-if="baseInfo.is_tls">
              <FormItem label="TLS模式">
                <RadioGroup v-model="baseInfo.tls_mode">
                  <Radio label="server_and_client">服务器和客户端验证</Radio>
                  <Radio label="client">仅客户端验证</Radio>
                </RadioGroup>
              </FormItem>
              <!--<Alert show-icon v-if="baseInfo.tls_mode === 'server_and_client'">请上传CA证书(TLS CA)，服务器证书(TLS certificate)，服务器密钥(TLS key)</Alert>-->
              <!--<Alert show-icon v-else>请上传服务器证书(TLS certificate)，服务器密钥(TLS key)</Alert>-->
              <FormItem label="TLS CA" style="width: 100%" prop="ca_cert" v-if="baseInfo.tls_mode === 'server_and_client'">
                <Upload :action="NodeUploadTlsUrl"
                        :headers="uploadHeader"
                        :on-success="uploadCASuccess"
                        :on-error="uploadError"
                        :on-format-error="uploadFormatError"
                        :on-exceeded-size="uploadExceededSize"
                        :show-upload-list="false"
                        :max-size="1024">
                  <Button icon="ios-cloud-upload-outline">上传CA证书</Button>
                  <Icon type="md-checkmark" size="22" style="margin-left: 10px; color: #19be6b" v-if="baseInfo.ca_cert" />
                </Upload>
              </FormItem>
              <FormItem label="TLS certificate" style="width: 100%" prop="client_cert">
                <Upload :action="NodeUploadTlsUrl"
                        :headers="uploadHeader"
                        :on-success="uploadClientCertSuccess"
                        :on-error="uploadError"
                        :on-format-error="uploadFormatError"
                        :on-exceeded-size="uploadExceededSize"
                        :show-upload-list="false"
                        :max-size="1024">
                  <Button icon="ios-cloud-upload-outline">上传服务器证书</Button>
                  <Icon type="md-checkmark" size="22" style="margin-left: 10px; color: #19be6b" v-if="baseInfo.client_cert" />
                </Upload>
              </FormItem>
              <FormItem label="TLS key" style="width: 100%" prop="client_key">
                <Upload :action="NodeUploadTlsUrl"
                        :headers="uploadHeader"
                        :on-success="uploadClientKeySuccess"
                        :on-error="uploadError"
                        :on-format-error="uploadFormatError"
                        :on-exceeded-size="uploadExceededSize"
                        :show-upload-list="false"
                        :max-size="1024">
                  <Button icon="ios-cloud-upload-outline">上传服务器密钥</Button>
                  <Icon type="md-checkmark" size="22" style="margin-left: 10px; color: #19be6b" v-if="baseInfo.client_key" />
                </Upload>
              </FormItem>
            </div>
          </Row>
        </Form>
      </div>
      <div style="text-align: center;">
        <Button type="primary" style="margin-right: 10px" :loading="submitting" @click="submit">提交</Button>
        <Button @click="$router.go(-1)">取消</Button>
      </div>
    </Card>
  </div>
</template>

<script>
import { NodeUploadTlsUrl, changeNode, detailNode } from '@/api/container/node'
export default {
  name: 'edit',
  data () {
    return {
      NodeUploadTlsUrl: NodeUploadTlsUrl,
      uploadHeader: {
        Authorization: 'OPS ' + this.$store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      baseInfo: {
        id: '',
        name: '',
        url: '',
        is_tls: false,
        tls_mode: 'server_and_client',
        ca_cert: null,
        client_cert: null,
        client_key: null
      },
      baseInfoFormRules: {
        name: { required: true, message: '节点名称不能为空', trigger: 'blur' },
        url: { required: true, message: 'URL不能为空', trigger: 'blur' },
        is_tls: { required: true, message: '', trigger: 'change', type: 'boolean' },
        tls_mode: { required: true, message: '请选择TLS模式', trigger: 'change' },
        ca_cert: { required: true, message: '请上传CA证书', trigger: 'change', type: 'number' },
        client_cert: { required: true, message: '请上传服务器证书', trigger: 'change', type: 'number' },
        client_key: { required: true, message: '请上传服务器密钥', trigger: 'change', type: 'number' }
      },
      submitting: false
    }
  },
  created: function () {
    this.init()
  },
  watch: {
    '$route' () {
      this.init()
    }
  },
  methods: {
    // 初始化
    init () {
      if (this.$route.params.id) {
        this.getData()
      }
    },
    getData () {
      detailNode(this.$route.params.id).then(res => {
        for (let i in this.baseInfo) {
          this.baseInfo[i] = res.data[i]
        }
      })
    },
    // 上传CA成功
    uploadCASuccess (res) {
      this.baseInfo.ca_cert = res.id
      this.$Notice.success({
        title: '上传成功'
      })
    },
    // 上传Client Cert成功
    uploadClientCertSuccess (res) {
      this.baseInfo.client_cert = res.id
      this.$Notice.success({
        title: '上传成功'
      })
    },
    // 上传Client Key附件成功
    uploadClientKeySuccess (res) {
      this.baseInfo.client_key = res.id
      this.$Notice.success({
        title: '上传成功'
      })
    },
    // 上传测失败
    uploadError (err, msg) {
      this.$Notice.error({
        title: '上传失败',
        desc: msg
      })
      console.log(err)
    },
    // 上传格式不对
    uploadFormatError () {
      this.$Notice.error({
        title: '只能上传格式为docx/xlsx/pdf的文件'
      })
    },
    // 上传超过限制大小
    uploadExceededSize () {
      this.$Notice.error({
        title: '限制文件大小为1M'
      })
    },
    submit () {
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          if (this.baseInfo.tls_mode === 'client') {
            this.baseInfo.ca_cert = null
          }
          this.submitting = true
          changeNode(this.baseInfo, this.baseInfo.id).then(res => {
            this.$Notice.success({
              title: '操作成功'
            })
            this.$router.push({name: 'container_node'})
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        } else {
          this.$Notice.warning({
            title: '请检查表单！'
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  @import '../../base.less';
</style>
